//import Vue from 'vue'
import Vue from 'vue/dist/vue.js'
import Vuex from 'vuex'
import firebase from 'firebase'
import moment from 'moment-timezone'
import polyline from '@mapbox/polyline'
import axios from 'axios'
import router from '../../router'

import { createHelpers } from 'vuex-map-fields'

const { getMyRacesField, updateMyRacesField } = createHelpers({
  getterType: 'getMyRacesField',
  mutationType: 'updateMyRacesField',
});

export default {
  state: {
    messages: {
      live: {},
      racePepPoints: {}
    },
  },
  getters: {
    myRacesMessages: state => state.messages,
    getMyRacesField
  },
  mutations: {
    setMessages(state, data) {
      state.messages.live = data.live
      state.messages.racePepPoints = data.racePepPoints
    },
    updateMyRacesField
  },
  actions: {
    /*getRace(context, raceData) {
        axios.get('https://us-central1-racepeps.cloudfunctions.net/race/races/v2/' + raceData.publicId)
        .then(response => {
          console.log(response.data)
          context.commit('setMessages', response.data)
          context.dispatch('setRaceRef', { 'raceId': raceData.raceId, 'myRaces': true })
          router.replace('/myracesinformation')
        })
        .catch(function (error) {
          console.log("error in getting race messages")
          console.log(error);
        })
    },*/
  }
}
